import qs from 'qs'

import api from '@/services/base.service'

const methods = {
  getDashboardDataset(dataset, bodegaId, desde, hasta, parametros = {}) {
    const params = JSON.stringify(parametros)
    return api.get(`/dashboards/${dataset}`, {
      params: {
        bodegaId,
        desde,
        hasta,
        parametros: params
      },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  exportarDataset(dataset, bodegaId, desde, hasta, parametros = {}) {
    const params = JSON.stringify(parametros)
    return api.get(`/dashboards/${dataset}/exportar`, {
      responseType: 'blob',
      params: {
        bodegaId,
        desde,
        hasta,
        parametros: params
      },
      paramsSerializer: (params) => qs.stringify(params)
    })
  }
}

export default methods
